import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Input } from "@/components/ui/input"
import { Plus, Image, Video, Trash2, Edit } from "lucide-react"
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { TopNav } from '@/components/layout/top-nav'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search as SearchComponent } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'

const topNav = [
  { title: 'Anasayfa', href: '/', isActive: false },
]

const images = [
  { id: 1, title: "Depo Görüntüsü 1", category: "Depo", url: "/gallery/1.jpg", date: "18.02.2026" },
  { id: 2, title: "Filomuz", category: "Araçlar", url: "/gallery/2.jpg", date: "15.02.2026" },
  { id: 3, title: "Ofis", category: "Kurumsal", url: "/gallery/3.jpg", date: "10.02.2026" },
]

const videos = [
  { id: 1, title: "Tanıtım Filmi", category: "Tanıtım", url: "/video/1.mp4", date: "01.02.2026" },
]

export default function Galeri() {
  return (
    <>
      <Header>
        <TopNav links={topNav} />
        <div className="ml-auto flex items-center gap-2">
          <SearchComponent />
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main>
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Galeri</h1>
            <p className="text-sm text-muted-foreground">Resim ve videolarınızı yönetin</p>
          </div>
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            Yeni Ekle
          </Button>
        </div>

      <Tabs defaultValue="images">
        <TabsList className="w-full sm:w-auto">
          <TabsTrigger value="images" className="flex-1 sm:flex-none"><Image className="mr-2 h-4 w-4" />Resimler</TabsTrigger>
          <TabsTrigger value="videos" className="flex-1 sm:flex-none"><Video className="mr-2 h-4 w-4" />Videolar</TabsTrigger>
        </TabsList>
        <TabsContent value="images">
          <Card>
            <CardHeader className="pb-3">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <CardTitle>Resim Galerisi</CardTitle>
                <Input placeholder="Resim ara..." className="w-full sm:w-[200px]" />
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {images.map((img) => (
                  <div key={img.id} className="relative group aspect-square bg-muted rounded-lg overflow-hidden">
                    <div className="absolute inset-0 bg-black/50 group-hover:flex items-center justify-center hidden">
                      <Button variant="ghost" size="icon"><Edit className="h-4 w-4 text-white" /></Button>
                      <Button variant="ghost" size="icon"><Trash2 className="h-4 w-4 text-white" /></Button>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70">
                      <p className="text-white text-sm font-medium">{img.title}</p>
                      <Badge variant="secondary" className="text-xs">{img.category}</Badge>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="videos">
          <Card>
            <CardHeader className="pb-3">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <CardTitle>Video Galerisi</CardTitle>
                <Input placeholder="Video ara..." className="w-full sm:w-[200px]" />
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {videos.map((vid) => (
                  <div key={vid.id} className="relative aspect-video bg-muted rounded-lg">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <Video className="h-12 w-12 text-muted-foreground" />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70">
                      <p className="text-white text-sm font-medium">{vid.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
      </Main>
    </>
  )
}
